import * as stylex from '@stylexjs/stylex';
import { borderRadius, color, spacer } from '@figma/fpl-tokens/tokens.stylex';

export const DEFAULT_FILE_UPLOAD_HEIGHT = 208;

export const styles = stylex.create({
  media: (height: number) => ({
    position: 'relative',
    borderRadius: 4,
    width: '100%',
    height,
    boxSizing: 'border-box',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  }),
  visualMedia: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
  intrinsicMedia: {
    height: 'auto',
    maxHeight: DEFAULT_FILE_UPLOAD_HEIGHT,
    alignItems: 'stretch',
  },
  intrinsicVisualMedia: {
    height: 'auto',
  },
  mediaBackground: (background: string) => ({ background }),
  progress: { width: '100%', position: 'absolute', top: 0, left: 0 },
  uploadPrompt: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: 'inherit',
    textAlign: 'center',
  },
  emptyHoverOverlay: {
    backgroundColor: color.bgSecondary,
  },
  uploadOutline: (borderColor: string) => ({
    position: 'absolute',
    top: 0.5,
    left: 0.5,
    width: 'calc(100% - 1px)',
    height: 'calc(100% - 1px)',
    overflow: 'visible',
    pointerEvents: 'none',
    stroke: borderColor,
    zIndex: 2,
  }),
  uploadOutlineShape: {
    fill: 'none',
    strokeDasharray: '4 4',
    strokeLinecap: 'round',
  },
  uploadIconError: {
    '--fpl-icon-color': color.textDanger,
  },
  disabledIcon: {
    '--fpl-icon-color': color.iconDisabled,
  },
  dropzone: {
    width: '100%',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacer.spacer8px,
  },
  fileList: {
    width: '100%',
    boxSizing: 'border-box',
    alignContent: 'flex-start',
    padding: 2,
  },
  progressTile: {
    width: 64,
    height: 64,
    boxSizing: 'border-box',
    borderRadius: borderRadius.medium,
    border: `1px solid ${color.border}`,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  frame: (borderColor: string) => ({
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor,
  }),
  replaceButton: {
    borderRadius: borderRadius.medium,
    paddingRight: spacer.spacer1, // need additional visual spacing on right
    backgroundColor: {
      default: 'transparent',
      ':hover': color.bgHover,
    }
  }
});
